export default {
  colors: {
    primary: "#386fa4",
    background: "#FFFFFF",
    shape: `#f7fbfe`,
    title: `#000`,
    text: `#000`,
    components: {
      blockquote: {
        background: `#f8f9fa`,
        text: `#000`,
      },
    },
  },
  fonts: {
    body: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
  },
};
